import React from 'react';
import Accordion from '../../components/Accordion';

const Accordions = () => (<div className="styles-section row" id="accordions">
  <div className='main-page-title col-12'>
    <h3>Accordions</h3>
  </div>
  <div className='home-page-content col-sm-12 col-md-4'>
    <Accordion
      collapsibles={[{
        header: "Collapsible Group Item #1",
        title: 'Title',
        content: 'Some placeholder content for the first accordion panel. This panel is shown by default, thanks to the <code>.show</code> class.'
      }, {
        header: "Collapsible Group Item #2",
        title: 'Title 2',
        content: 'Some placeholder content for the second accordion panel. This panel is hidden by default.'
      }, {
        header: "Collapsible Group Item #3",
        title: 'Title 3',
        content: 'And lastly, the placeholder content for the third and final accordion panel. This panel is hidden by default.'
      }]} />
  </div>
  <div className='home-page-content col-sm-12 col-md-4'>
    <Accordion
      defaultActiveIndex={1}
      collapsibles={[{
        header: "Collapsible Group Item #1",
        title: 'Title',
        content: 'Some placeholder content for the first accordion panel. This panel is shown by default, thanks to the <code>.show</code> class.',
      }, {
        header: "Collapsible Group Item #2",
        title: 'Title 2',
        content: 'Some placeholder content for the second accordion panel. This panel is hidden by default.'
      }, {
        header: "Collapsible Group Item #3",
        title: 'Title 3',
        content: 'And lastly, the placeholder content for the third and final accordion panel. This panel is hidden by default.'
      }]} />
  </div>
  <div className='home-page-content col-sm-12 col-md-4'>
    <Accordion
      defaultActiveIndex={3}
      collapsibles={[{
        header: "Collapsible Group Item #1",
        title: 'Title',
        content: 'Some placeholder content for the first accordion panel. This panel is shown by default, thanks to the <code>.show</code> class.'
      }, {
        header: "Collapsible Group Item #2",
        title: 'Title 2',
        content: 'Some placeholder content for the second accordion panel. This panel is hidden by default.'
      }, {
        header: "Collapsible Group Item #3",
        title: 'Title 3',
        content: 'And lastly, the placeholder content for the third and final accordion panel. This panel is hidden by default.',
      }]} />
  </div>
</div>);

export default Accordions;